<template>
    <label class="pp-radio"
        :class="[
            'pp-radio--' + currentSize,
            {'is-active': isActive, 'is-disabled': isDisabled}]">
        <input class="pp-radio__input" 
            type="checkbox" 
            v-bind="$attrs"
            :value="label" 
            :checked="checked" :disabled="isDisabled"
            @change="change"/>
        <i class="pp-radio__icon" :class="[isActive ? currentActiveIcon : currentIcon]"
            :style="{color: currentColor, float: currentAlign}"></i>
        <span class="pp-radio__label" :style="{color: currentColor}">
            <slot>{{label}}</slot>
        </span>
    </label>
</template>

<script>
/**
 * 多选
 * @param {*} value 单组件使用 v-model绑定值 返回一个Boolean，true选中，false未选中
 * @param {[string, number]} label 选中值 pp-checkbox-group使用
 * @param {boolean} disabled 禁用状态
 * @param {boolean} checked 默认选中状态
 * @param {string} color 选中颜色
 * @param {string} size 尺寸 [normal默认, small, mini]
 * @param {string} icon 未选中时图标
 * @param {string} activeIcon 选中时图标
 * @param {string} align 按钮对齐方式 ['right']
 */
export default {
    name: 'pp-checkbox',
    inheritAttrs: false,
    inject: {
        Form: {
            default: ''
        },
        FormItem: {
            default: ''
        },
        CheckboxGroup: {
            default: ''
        },
    },
    props: {
        value: {},
        label: [String, Number],
        disabled: Boolean,
        checked: Boolean,
        color: String,
        size: {
            type: String,
            default: 'normal',
        },
        icon: {
            type: String,
            default: 'pp-icon-checkbox-unchecked',
        },
        activeIcon: {
            type: String,
            default: 'pp-icon-checkbox-checked',
        },
        align: {
            type: String,
            validator: function(value) {
                return ['right'].includes(value);
            },
        },
    },
    computed: {
        isGroup: function() {
            return this.$parent.$options.name === 'pp-checkbox-group' 
                && typeof this.value !== 'boolean';
        },
        isActive: function() {
            return this.isGroup
                ? !!this.currentValue.find(v=> v === this.label)
                : !!this.currentValue;
        },
        isDisabled: function() {
            return this.Form.disabled 
                || (this.isGroup ? this.$parent.currentDisabled : this.disabled)
                || this.disabled;
        },
        currentColor: function() {
            return this.isGroup 
                ? this.$parent.color || this.color 
                : this.color;
        },
        currentIcon: function() {
            return this.isGroup 
                ? this.$parent.icon || this.icon 
                : this.icon;
        },
        currentActiveIcon: function() {
            return this.isGroup 
                ? this.$parent.activeIcon || this.activeIcon 
                : this.activeIcon;
        },
        currentSize: function() {
            return this.Form.size 
                || this.FormItem.size 
                || this.CheckboxGroup.size
                || this.size;
        },
        currentValue: function() {
            return this.isGroup 
                ? this.$parent.value 
                : this.value;
        },
        currentAlign: function() {
            return this.align || this.CheckboxGroup.align;
        },
    },
    methods: {
        change: function() {
            this.isGroup 
                ? this.$parent.update(this.label) 
                : this.update()
        },
        update: function() {
            if(this.isGroup) {
                this.$parent.update(this.label)
                this.$emit('change', this.label)
            }
            else {
                this.$emit('input', !this.currentValue)
                this.$emit('change', !this.currentValue)
            }
        },
    },
    created: function() {
        this.checked && this.update()
        this.isGroup 
            // && (!this.isDisabled || this.checked) 看情况处理disabled在全选中的问题
            && this.$parent.childrenValue.push(this.label)
    },

}
</script>
